module.exports = __webpack_public_path__ + "img/gift.79b0a4a6.png";